import React from "react";
import { PromotionUpdateForm } from "@components";

const PromotionUpdate = ({ history }) => {
  return (
    <div style={{ minHeight: "100vh", background: "#f5f5f5" }}>
      <PromotionUpdateForm />
    </div>
  );
};

export default PromotionUpdate;
